/* ==========================================================================
   Furora theme motion system — scroll reveal
   Auto-tags common content blocks with [data-motion] and reveals them with
   an IntersectionObserver as they scroll into view. Additive only: it never
   edits section markup on the server, and does nothing if the visitor has
   requested reduced motion or if JS fails to load (see theme-motion.css).
   ========================================================================== */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var STAGGER_STEP_MS = 80;
  var MAX_STAGGER_MS = 480;

  function tagWholeSections(main) {
    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (section) {
      if (!section.hasAttribute('data-motion')) {
        section.setAttribute('data-motion', 'fade');
      }
    });
  }

  function tagStaggeredGroup(nodeList) {
    var indexByParent = new WeakMap();
    nodeList.forEach(function (el) {
      if (el.hasAttribute('data-motion')) return;
      var parent = el.parentElement;
      var idx = indexByParent.get(parent) || 0;
      var delay = Math.min(idx * STAGGER_STEP_MS, MAX_STAGGER_MS);
      el.setAttribute('data-motion', 'scale');
      el.style.setProperty('--motion-delay', delay + 'ms');
      indexByParent.set(parent, idx + 1);
    });
  }

  function tagContent() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    tagWholeSections(main);
    tagStaggeredGroup(main.querySelectorAll('.grid__item'));
    tagStaggeredGroup(main.querySelectorAll('.bundle-deals__product'));
    tagStaggeredGroup(main.querySelectorAll('.comparison-table tbody tr'));
  }

  function reveal() {
    var targets = document.querySelectorAll('[data-motion]:not(.is-inview)');

    if (!('IntersectionObserver' in window) || targets.length === 0) {
      targets.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    tagContent();
    reveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-tag and re-observe when the theme editor swaps a section in/out.
  document.addEventListener('shopify:section:load', init);
})();
